import { render } from "./BioPage.vue?vue&type=template&id=0cda1628&scoped=true"
import script from "./BioPage.vue?vue&type=script&lang=js"
export * from "./BioPage.vue?vue&type=script&lang=js"

import "./BioPage.vue?vue&type=style&index=0&id=0cda1628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cda1628"]])

export default __exports__